module.exports = __webpack_public_path__ + "img/bg-page.d886727b.png";